var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "批量新增人员成本",
        visible: _vm.dialogVisible,
        width: "920px",
        "append-to-body": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.onOpen
      }
    },
    [
      _c("div", { staticClass: "batch-tip" }, [
        _vm._v(
          "每行填写一条成本：岗位、人员、成本类型、金额。可添加多行后一次性保存。"
        )
      ]),
      _c(
        "div",
        { staticClass: "table-toolbar" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                plain: "",
                icon: "el-icon-plus",
                size: "small"
              },
              on: { click: _vm.addRow }
            },
            [_vm._v("添加一行")]
          ),
          _vm.rows.length
            ? _c("span", { staticClass: "row-count" }, [
                _vm._v("共 " + _vm._s(_vm.rows.length) + " 行")
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "batch-table",
          attrs: {
            data: _vm.rows,
            border: "",
            size: "small",
            "max-height": "360"
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "#", width: "44", align: "center" }
          }),
          _c("el-table-column", {
            attrs: { label: "岗位", "min-width": "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { size: "mini", placeholder: "岗位" },
                        model: {
                          value: scope.row.stationName,
                          callback: function($$v) {
                            _vm.$set(scope.row, "stationName", $$v)
                          },
                          expression: "scope.row.stationName"
                        }
                      },
                      _vm._l(_vm.stationOptions, function(s) {
                        return _c("el-option", {
                          key: s.value,
                          attrs: { label: s.label, value: s.value }
                        })
                      }),
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "人员", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("cargo-advance-select", {
                      key: "user-" + scope.row._rowKey,
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        "select-type": _vm.selectTypeNames.basic_data_User,
                        "default-value": scope.row.userId || null,
                        "callback-params": {
                          key: "userId",
                          rowIndex: scope.$index
                        }
                      },
                      on: { parentCallBack: _vm.onUserSelected }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "成本类型", "min-width": "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { size: "mini", placeholder: "类型" },
                        model: {
                          value: scope.row.costType,
                          callback: function($$v) {
                            _vm.$set(scope.row, "costType", $$v)
                          },
                          expression: "scope.row.costType"
                        }
                      },
                      _vm._l(_vm.costTypeOptions, function(t) {
                        return _c("el-option", {
                          key: t.value,
                          attrs: { label: t.label, value: t.value }
                        })
                      }),
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "金额", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        size: "mini",
                        min: 0,
                        precision: 2,
                        step: 100,
                        controls: false,
                        placeholder: "金额"
                      },
                      model: {
                        value: scope.row.amount,
                        callback: function($$v) {
                          _vm.$set(scope.row, "amount", $$v)
                        },
                        expression: "scope.row.amount"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "备注", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input", {
                      attrs: {
                        size: "mini",
                        placeholder: "选填",
                        maxlength: "500"
                      },
                      model: {
                        value: scope.row.remark,
                        callback: function($$v) {
                          _vm.$set(scope.row, "remark", $$v)
                        },
                        expression: "scope.row.remark"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "按月累加", width: "78", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-checkbox", {
                      model: {
                        value: scope.row.autoMonthlyChecked,
                        callback: function($$v) {
                          _vm.$set(scope.row, "autoMonthlyChecked", $$v)
                        },
                        expression: "scope.row.autoMonthlyChecked"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "64",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#F56C6C" },
                        attrs: { type: "text", disabled: _vm.rows.length <= 1 },
                        on: {
                          click: function($event) {
                            return _vm.removeRow(scope.$index)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.submitting },
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitting },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }